// serviceWorkerRegistration.js
const isLocalhost = Boolean(
	window.location.hostname === 'localhost' ||
	window.location.hostname === '[::1]' ||
	window.location.hostname.match(/^127(?:\.\d+){3}$/)
  );
  
  export function register(config) {
	if ('serviceWorker' in navigator) {
	  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  
	  if (isLocalhost) {
		// Check if service worker exists on localhost
		checkValidServiceWorker(swUrl, config);
		navigator.serviceWorker.ready.then(() => {
		  console.log('App is running in offline mode using cached resources.');
		});
	  } else {
		// Register service worker for production
		registerValidSW(swUrl, config);
	  }
	}
  }
  
  function registerValidSW(swUrl, config) {
	navigator.serviceWorker.register(swUrl)
	  .then((registration) => {
		console.log('Service Worker registered with scope:', registration.scope);
  
		if (config && config.onUpdate) {
		  registration.onupdatefound = () => {
			const installingWorker = registration.installing;
			if (installingWorker) {
			  installingWorker.onstatechange = () => {
				if (installingWorker.state === 'installed') {
				  if (navigator.serviceWorker.controller) {
					console.log('New content available. Please refresh the page.');
					config.onUpdate(registration);
				  } else {
					console.log('Content cached for offline use.');
					config.onSuccess && config.onSuccess();
				  }
				}
			  };
			}
		  };
		}
	  })
	  .catch((error) => {
		console.error('Service Worker registration failed:', error);
		config?.onError?.(error);
	  });
  }
  
  function checkValidServiceWorker(swUrl, config) {
	fetch(swUrl)
	  .then((response) => {
		if (!response || response.status === 404 || !response.headers.get('content-type')?.includes('javascript')) {
		  navigator.serviceWorker.ready.then((registration) => {
			registration.unregister().then(() => {
			  console.log('Invalid service worker. Reloading page.');
			  window.location.reload();
			});
		  });
		} else {
		  registerValidSW(swUrl, config);
		}
	  })
	  .catch(() => {
		console.log('No internet connection. Running in offline mode.');
	  });
  }
  
  export function unregister() {
	if ('serviceWorker' in navigator) {
	  navigator.serviceWorker.ready.then((registration) => {
		registration.unregister().then(() => {
		  console.log('Service Worker unregistered.');
		});
	  });
	}
  }